"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestUserMailChangeResult = void 0;
var GuestUserMailChangeResult;
(function (GuestUserMailChangeResult) {
    GuestUserMailChangeResult["invalidToken"] = "invalidToken";
    GuestUserMailChangeResult["successful"] = "successful";
    GuestUserMailChangeResult["tokenExpired"] = "tokenExpired";
})(GuestUserMailChangeResult || (exports.GuestUserMailChangeResult = GuestUserMailChangeResult = {}));
//# sourceMappingURL=GuestUserMailChangeResult.js.map